import { useDynamicEntity } from './useDynamicEntity';
import { useAuth } from './index';

const useTags = () => {
  const { user } = useAuth();
  const dynamicHook = useDynamicEntity({
    entityType: 'tags',
    gqlEntityKey: 'tags',
    queryName: 'GET_TAGS_QUERY',
    createMutation: 'CREATE_TAG_MUTATION',
    updateMutation: 'UPDATE_TAG_MUTATION',
    deleteMutation: 'DELETE_TAG_MUTATION',
    updateVariableName: 'set',
    transformData: (tag) => ({
      ...tag,
      company_name: tag.company?.name || `Company ${tag.company_id}`,
      name: tag.name,
      tags_color: tag.tags_color,
      tags_page: tag.tags_page,
      companyId: tag.company_id,
    }),
    transformFormData: (formData) => ({
      name: formData.name,
      tags_color: formData.tags_color || '#000000',
      tags_page: formData.tags_page || 'JOBS',
      company_id: formData.companyId || user?.companyId,
    }),
    customWhereCondition: user?.role === 'ROOT' ? {} : { company_id: { _eq: user?.companyId } },
  });
  return {
    ...dynamicHook,
    isRootUser: user?.role === 'ROOT',
  };
};

export { useTags }; 